import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchExportedBatch(agro_exporter_id, exported_batch_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_exported_batch/${agro_exporter_id}/fetch_exported_batch/${exported_batch_id}`
    );
  },
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_exported_batch/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchDiscardedMotives(agro_exporter_id, exported_batch_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_exported_batch/${agro_exporter_id}/fetch_discarded_motives/${exported_batch_id}`
    );
  },
};
